import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const mk = (bg, emoji, pulse) => L.divIcon({
  className: "",
  html: `<div style="position:relative;width:36px;height:36px">
    ${pulse ? `<div style="position:absolute;inset:-6px;border-radius:50%;background:${bg};opacity:.25;animation:stuffping 1.5s infinite"></div>` : ""}
    <div style="width:36px;height:36px;border-radius:50%;background:#0c0e11;border:2px solid ${bg};display:flex;align-items:center;justify-content:center;font-size:17px;box-shadow:0 0 12px ${bg}66">${emoji}</div>
  </div>`,
  iconSize: [36, 36],
  iconAnchor: [18, 18],
});

export const LiveCourierMap = ({ courier, dest }) => {
  const divRef = useRef(null);
  const mapRef = useRef(null);
  const layersRef = useRef([]);

  useEffect(() => {
    if (!divRef.current || mapRef.current) return;
    const style = document.createElement("style");
    style.textContent = "@keyframes stuffping{0%{transform:scale(.6);opacity:.4}80%{transform:scale(1.6);opacity:0}100%{opacity:0}}.stuff-dark-map .leaflet-tile-pane{filter:invert(1) hue-rotate(180deg) brightness(.75) contrast(1.1) saturate(.5)}";
    document.head.appendChild(style);
    const map = L.map(divRef.current, { zoomControl: false, attributionControl: false, scrollWheelZoom: false });
    divRef.current.classList.add("stuff-dark-map");
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(map);
    map.setView([48.86, 2.35], 12);
    mapRef.current = map;
    return () => { map.remove(); mapRef.current = null; style.remove(); };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    layersRef.current.forEach((l) => map.removeLayer(l));
    layersRef.current = [];
    const pts = [];
    if (dest) {
      layersRef.current.push(L.marker(dest, { icon: mk("#C026D3", "📍") }).addTo(map));
      pts.push(dest);
    }
    if (courier) {
      layersRef.current.push(L.marker(courier, { icon: mk("#9DFF00", "🛵", true) }).addTo(map));
      pts.push(courier);
    }
    if (courier && dest) {
      layersRef.current.push(L.polyline([courier, dest], { color: "#9DFF00", dashArray: "4 10", weight: 3, opacity: 0.9 }).addTo(map));
    }
    if (pts.length > 1) map.fitBounds(L.latLngBounds(pts).pad(0.35));
    else if (pts.length === 1) map.setView(pts[0], 14);
  }, [courier?.[0], courier?.[1], dest?.[0], dest?.[1]]); // eslint-disable-line react-hooks/exhaustive-deps

  return <div ref={divRef} data-testid="live-courier-map" className="h-64 sm:h-72 w-full" />;
};
